import { Pipe, PipeTransform } from '@angular/core';
import { stripHtml } from '../util/fn';

@Pipe({
    name: 'striphtml'
})

export class StripHtmlPipe implements PipeTransform {
    transform(value: string): any {
        return stripHtml(value); // replace tags
    }
}